const LOADING_SCREEN_ID = 'di-loader'
const LOADING_SCREEN_SPINNER_SELECTOR = '.di-loader__border'
const LOADING_SCREEN_PROGRESS_ID = 'di-loader__text_progress'

export function useLoadingScreen() {
    const setLoadingScreenVisible = (visible: boolean = false) => {
        const loader = document.getElementById(LOADING_SCREEN_ID)
        if (loader) {
            loader.style.display = visible ? '' : 'none'
        }
    }

    const setSpinnerRunning = (running: boolean = false) => {
        const loader = document.getElementById(LOADING_SCREEN_ID)
        const spinner = loader?.querySelector(LOADING_SCREEN_SPINNER_SELECTOR) as HTMLElement | null
        if (spinner) {
            spinner.style.animationPlayState = running ? 'running' : 'paused'
        }
    }

    const hide = () => {
        setLoadingScreenVisible(false)
        setSpinnerRunning(false)
    }

    const setLoaderWidth = (progressFraction: number) => {
        const progressElem = document.getElementById(LOADING_SCREEN_PROGRESS_ID)
        if (progressElem) {
            progressElem.style.width = `${Math.min(progressFraction * 200, 200)}`
        }
    }

    const show = ({ progressFraction }: { progressFraction?: number }) => {
        if (progressFraction !== undefined) {
            setLoaderWidth(progressFraction)
        }
        setSpinnerRunning(true)
        setLoadingScreenVisible(true)
    }

    return { hide, show }
}
